/**
 * Insignia del estado de un talonario (presentacional).
 *
 * Replica los badges del SSR `supervisor_talonarios` (`progress/
 * explore_talonarios_ssr.md`, §2.1): "Agotado" (sin disponibles), "Pocos números"
 * (<= 5) o "Normal". Sin lógica de datos: recibe las banderas ya calculadas por el
 * backend (`is_exhausted`/`is_low`).
 */
interface TalonarioStateBadgeProps {
  isExhausted: boolean;
  isLow: boolean;
}

const BASE =
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium";

export function TalonarioStateBadge({
  isExhausted,
  isLow,
}: TalonarioStateBadgeProps) {
  if (isExhausted) {
    return <span className={`${BASE} bg-red-100 text-red-700`}>Agotado</span>;
  }
  if (isLow) {
    return (
      <span className={`${BASE} bg-amber-100 text-amber-700`}>Pocos números</span>
    );
  }
  return <span className={`${BASE} bg-emerald-100 text-emerald-700`}>Normal</span>;
}
